import useApi from "./useApi";

const useVendorOrders = ({ query = {}, page = 1, perPage = 10 } = {}) => {
  const { getbyobj } = useApi();

  const params = { ...query, page, per_page: perPage };

  const { data, isLoading, error } = getbyobj("/vendor/orders", params);

  return {
    orders: data?.data?.orders || [],
    pagination: {
      current_page: data?.data?.current_page || 1,
      per_page: data?.data?.per_page || perPage,
      total: data?.data?.total || 0,
      last_page: data?.data?.last_page || 1,
    },
    isLoading,
    error,
  };
};

export default useVendorOrders;
